import { parseDomain } from '../../utils';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
export const canPurchaseOrConnect = async _ref => {
  let httpClient = _ref.httpClient,
    _ref$request = _ref.request,
    domain = _ref$request.domain,
    msid = _ref$request.msid;
  if (!domain) {
    return {
      canPurchase: false,
      canConnect: false
    };
  }
  const parsedDomain = domain.main ? domain : parseDomain(domain);
  const _await$dynamicLoadApi = await dynamicLoadApiQueries(httpClient),
    canPurchaseDomain = _await$dynamicLoadApi.canPurchaseDomain,
    canConnectOrBindDomain = _await$dynamicLoadApi.canConnectOrBindDomain;
  const _await$Promise$all = await Promise.all([canPurchaseDomain({
      domain: parsedDomain.asciiDomain
    }), canConnectOrBindDomain({
      domain: parsedDomain.asciiDomain,
      msid: msid ?? ''
    })]),
    canPurchase = _await$Promise$all[0],
    canConnect = _await$Promise$all[1];
  return {
    canPurchase: canPurchase.canPurchase,
    canConnect: canConnect.canConnectOrBind,
    purchaseError: canPurchase.error,
    connectError: canConnect.error
  };
};
//# sourceMappingURL=canPurchaseOrConnect.js.map